package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import kotlin.String
import com.jingfangpai.common.orm.mapping.Acupoint

object AcupointApiClient :BaseServiceClient() {

	@JsName("getById")
	fun getById(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Acupoint>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"id" to "${id?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Acupoint> = httpClient.get {
				    url("/api/acupoint/getById?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getDetail")
	fun getDetail(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.acupoint.model.AcupointDetail>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"id" to "${id?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.acupoint.model.AcupointDetail> = httpClient.get {
				    url("/api/acupoint/detail?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getList")
	fun getList( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.Acupoint>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.Acupoint>> = httpClient.get {
				    url("/api/acupoint/list?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("listIdAndName")
	fun listIdAndName( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.data.model.IdName>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.data.model.IdName>> = httpClient.get {
				    url("/api/acupoint/listIdAndName?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("save")
	fun save(acupoint:com.jingfangpai.common.orm.mapping.Acupoint, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Acupoint>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Acupoint> = httpClient.post {
				    url("/api/acupoint/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.Acupoint.serializer(),acupoint), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
